import LinkButton from '@carvana/ds-link-button';
import { icon } from '@carvana/ds-styles';
import cx from 'classnames';
import { MapPin } from 'lucide-react';
import { useContext } from 'react';
import { useUserLocation } from '~/context/common/UserContext';
import ModalContext from '~/context/srp/ModalContext';

export default function GeoLocationButton() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { zip } = useUserLocation();

  const promptGeoModal = () => {
    setGeolocationModalOpen(true);
  };

  return (
    <LinkButton
      variant="default"
      size="sm"
      className="w-fit"
      underline={false}
      data-adobe-id="geo-location"
      data-analytics-id="Geo Location"
      data-testid="geo-location"
      onClick={promptGeoModal}
    >
      <span className="flex items-center gap-sm text-text-primary t-label-sm sm:gap-md">
        <MapPin color={icon.primary} size={16} />
        <span className={cx('m-0 truncate', { 'text-text-weak': !zip })}>
          {zip ? `${zip}` : 'Current location'}
        </span>
      </span>
    </LinkButton>
  );
}
